export const APP_VERSION = process.env.REACT_APP_VERSION;

/**
 * KEYCLOAK
 */
export const KEYCLOAK_URL = process.env.REACT_APP_KC_URL;
export const KEYCLOAK_REALM = process.env.REACT_APP_KC_REALM;
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KC_CLIENT_ID;

/**
 * ROLES
 */
export const ROLE_TIIVII_SUPER_USER = "TIIVII_SUPER_USER";
export const ROLE_TIIVII_PARTNER_USER = "TIIVII_PARTNER_USER";
export const ROLE_TIIVII_TECHNICAL_USER = "TIIVII_TECHNICAL_USER";
export const ROLE_TIIVII_VIEWER_USER = "TIIVII_VIEWER_USER";

export const ROLES_ADMIN = [
  ROLE_TIIVII_SUPER_USER,
  ROLE_TIIVII_PARTNER_USER,
  ROLE_TIIVII_TECHNICAL_USER,
];
export const ROLES_ALL = [
  ROLE_TIIVII_SUPER_USER,
  ROLE_TIIVII_PARTNER_USER,
  ROLE_TIIVII_TECHNICAL_USER,
  ROLE_TIIVII_VIEWER_USER,
];

/**
 * HTTP ERROR CODES
 */
export const HTTP_CODE_401 = 401;

/**
 * NOTIFICATION SEVERITY
 */
export const SEVERITY_SUCCESS = "success";
export const SEVERITY_INFO = "info";
export const SEVERITY_WARNING = "warning";
export const SEVERITY_ERROR = "error";

/**
 * I18N
 */
export const LANGUAGES = ["es", "en", "gl"];
export const LANGUAGES_ES = "es";
export const LANGUAGE_DEFAULT = LANGUAGES_ES;

export const LOCAL_STORAGE_ITEMS = {
  LOCALE: "locale",
};

/**
 * BACKEND API
 */
export const DEFAULT_HTTP_TIMEOUT = 60000;
export const MARQUESINAS_API_BASE_URL =
  process.env.REACT_APP_MARQUESINAS_API_BASE_URL;

export const MARQUESINAS_API_BUS_STOPS =
  MARQUESINAS_API_BASE_URL + "bus-stops/";
export const MARQUESINAS_API_BUS_STOP_INFO =
  MARQUESINAS_API_BASE_URL + "bus-stops/:bus_stop_id";

/**
 * CSS CLASSES NAMES
 */
export const CLASSNAME_APP = "App";
export const LANDING_ERROR_BOUNDARY = "landingErrorBoundary;";

/**
 * CSS COLORS
 */
export const BLUE_049FE3 = "#049fe3";

/**
 * TAGS
 */
export const H_1 = "h1";
export const H_4 = "h4";

/**
 * SYMBOLS
 */
export const BACK_SLASH = "/";
export const ASTERISK = "*";
export const CONNECTOR_FIRST_URL_PARAMETER = "?";
export const CONNECTOR_URL_PARAMETER = "&";

export const LINK_TARGET_BLANK = "_blank";
export const LINK_TARGET_NO_REFER = "noreferrer";
